import React from 'react';
import { Instagram, Facebook, MapPin, Phone, Mail } from 'lucide-react';
import { Logo } from './Logo';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-espresso text-bone pt-16 pb-8 border-t border-white/10" data-id="element-51">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-52">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-53">
          <div className="md:col-span-2" data-id="element-54">
            <a href="#" className="block mb-6" data-id="element-55">
              <Logo variant="dark" size="md" data-id="element-56" />
            </a>
            <p className="text-bone/70 font-light max-w-sm leading-relaxed mb-6" data-id="element-57">
              Carpintería arquitectónica de alto impacto. Fabricación industrial
              y diseño de autor para proyectos residenciales y grandes
              constructoras.
            </p>
            <div className="flex space-x-4" data-id="element-58">
              <a href="https://www.instagram.com/carpinteriagym/" target="_blank" rel="noopener noreferrer" aria-label="Instagram de Carpintería G&M" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-gold hover:border-gold hover:text-espresso transition-all duration-300" data-id="element-59">
                <Instagram size={18} data-id="element-60" />
              </a>
              <a href="https://web.facebook.com/profile.php?id=61553537645971&locale=es_LA" target="_blank" rel="noopener noreferrer" aria-label="Facebook de Carpintería G&M" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-gold hover:border-gold hover:text-espresso transition-all duration-300" data-id="element-61">
                <Facebook size={18} data-id="element-62" />
              </a>
            </div>
          </div>

          <div data-id="element-63">
            <h4 className="text-gold font-serif text-lg mb-6" data-id="element-64">Contacto</h4>
            <ul className="space-y-4 text-bone/70 font-light" data-id="element-65">
              <li className="flex items-start" data-id="element-66">
                <MapPin size={18} className="mr-3 mt-1 text-gold shrink-0" data-id="element-67" />
                <span data-id="element-68">
                  Planta Principal
                  <br data-id="element-69" />
                  Carrera 25 # 57-51
                  <br data-id="element-70" />
                  Manizales, Colombia, 170004
                </span>
              </li>
              <li className="flex items-center" data-id="element-71">
                <Phone size={18} className="mr-3 text-gold shrink-0" data-id="element-72" />
                <span data-id="element-73">+57 300 273 0493 / +57 311 746 7135</span>
              </li>
              <li className="flex items-center" data-id="element-74">
                <Mail size={18} className="mr-3 text-gold shrink-0" data-id="element-75" />
                <span data-id="element-76">diseno.gymcarpinteria@gmail.com</span>
              </li>
            </ul>
          </div>

          <div data-id="element-77">
            <h4 className="text-gold font-serif text-lg mb-6" data-id="element-78">Enlaces</h4>
            <ul className="space-y-3 text-bone/70 font-light" data-id="element-79">
              <li data-id="element-80">
                <a href="#servicios" className="hover:text-gold transition-colors" data-id="element-81">
                  Líneas de Negocio
                </a>
              </li>
              <li data-id="element-82">
                <a href="#cobertura" className="hover:text-gold transition-colors" data-id="element-83">
                  Cobertura Nacional
                </a>
              </li>
              <li data-id="element-84">
                <a href="#portafolio" className="hover:text-gold transition-colors" data-id="element-85">
                  Portafolio
                </a>
              </li>
              <li data-id="element-86">
                <a href="#contacto" className="hover:text-gold transition-colors" data-id="element-87">
                  Solicitar Asesoría
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-bone/50 font-light" data-id="element-88">
          <p data-id="element-89">
            &copy; {currentYear} Carpintería G&M. Todos los derechos reservados.
          </p>
          <p className="mt-2 md:mt-0" data-id="element-90">Diseño y Manufactura Premium</p>
        </div>
      </div>
    </footer>;
}